module.exports = require("@ember/-internals/metal");